<template>
    <div class="row mb-3">
        <div class="col">
            <div class="d-inline-block mb-3">
                <select class="form-select d-inline-block" style="width: 120px" v-model="yearSelected">
                    <option v-for="y in yearRange" :value="y" class="text-center">{{ y }}</option>
                </select>
            </div>
            <button type="button" class="btn btn-primary mx-2" style="margin-bottom: 5px"
                    @click="getData()"><font-awesome-icon :icon="faMagnifyingGlass" class="me-2"/>Cari
            </button>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="pejabatLama" value="old" v-model="olderOffice">
                <label class="form-check-label" for="pejabatLama">Pejabat lama</label>
            </div>
            <form v-if="kaunterBulan.length > 0" class="d-inline-block" :action="uri_download_report_kaunter_bulan" method="post">
                <input type="hidden" name="_token" :value="csrf">
                <input type="hidden" v-if="olderOffice !== undefined" name="oldOffice" :value="olderOffice">
                <input type="hidden" name="year" :value="yearSelected">
                <button type="submit" class="btn btn-outline-success fs-6" ><font-awesome-icon :icon="faFileExcel" class="me-2" />Muat turun laporan</button>
            </form>
            <button type="button" class="btn btn-warning ms-2 float-end"
                    @click="goBack">
                <font-awesome-icon :icon="faChevronLeft" /> Kembali
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="wrapper" ref="wrapper">
                <table v-if="kaunterBulan.length > 0" class="table table-striped-columns">
                    <thead class="table-dark">
                    <tr>
                        <th class="text-center align-middle" style="width: 5px;" rowspan="3">Bil</th>
                        <th class="text-center align-middle" rowspan="3">Pejabat / Kaunter</th>
                        <th class="text-center" :colspan="months.length*2">Bulan</th>
                        <th class="text-center align-middle" colspan="2" rowspan="2">Jumlah</th>
                    </tr>
                    <tr>
                        <th v-for="month in months" colspan="2" class="text-center">{{ month }}</th>
                    </tr>
                    <tr>
                        <template v-for="monthh in months">
                            <th>Bil</th>
                            <th>Amaun</th>
                        </template>
                        <th>Bil</th>
                        <th>Amaun</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in kaunterBulan">
                        <td class="text-white fw-bold">{{ index + 1  }}</td>
                        <td class="text-white fw-bold">{{ item.office  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.janBil) }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.janAmount)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.febBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.febAmount)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.macBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.macAmount)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.aprBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.aprAmount)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.meiBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.meiAmount)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.junBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.junAmount)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.julBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.julAmount)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.ogoBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.ogoAmount)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.sepBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.sepAmount)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.oktBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.oktAmount)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.novBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.novAmount) }}</td>
                        <td class="text-end">{{ sumFormatWithoutDecimal(item.disBil)  }}</td>
                        <td class="text-end">{{ sumFormatWithoutCurrency(item.disAmount)  }}</td>
                        <td class="table-dark fw-bold text-end">{{ sumFormatWithoutDecimal(item.totalBil)  }}</td>
                        <td class="table-dark fw-bold text-end">{{ sumFormatWithoutCurrency(item.totalAmount)  }}</td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td class="border-right-0"></td>
                        <td class="text-center fw-bold text-white">Jumlah</td>
                        <td v-for="(grandSumInQue,index) in bills" class="table-dark fw-bold text-end">{{ (index%2 === 0)? sumFormatWithoutDecimal(grandSumInQue) : sumFormatWithoutCurrency(grandSumInQue) }}</td>
                        <td class="table-dark fw-bold text-end">{{ sumFormatWithoutDecimal(grandSum.grandSumBil) }}</td>
                        <td class="table-dark fw-bold text-end">{{ sumFormatWithoutCurrency(grandSum.grandSumAmount) }}</td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {onMounted, ref} from "vue";
import {sumFormatWithoutCurrency,sumFormatWithoutDecimal} from "../../utils/utils";
import axios, {AxiosError} from "axios";
import Swal from "sweetalert2";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {faChevronLeft, faFileExcel, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
library.add(faChevronLeft);
library.add(faFileExcel);
library.add(faMagnifyingGlass);

const data = defineProps<{
    uri_get_kaunter_bulan: string,
    uri_download_report_kaunter_bulan: string,
    year: number,
    csrf: string,
}>();

const emitToParent = defineEmits<{
    (e: "hidePage", flag: boolean): void,
    (e: "hideLoader"): void,
    (e: "showLoader"): void,
}>();

const yearRange = ref<number[]>([]);
const months = ref<string[]>([]);
const kaunterBulan = ref<{
    office: string,
    janBil: number,
    janAmount: number,
    febBil: number,
    febAmount: number,
    macBil: number,
    macAmount: number,
    aprBil: number,
    aprAmount: number,
    meiBil: number,
    meiAmount: number,
    junBil: number,
    junAmount: number,
    julBil: number,
    julAmount: number,
    ogoBil: number,
    ogoAmount: number,
    sepBil: number,
    sepAmount: number,
    oktBil: number,
    oktAmount: number,
    novBil: number,
    novAmount: number,
    disBil: number,
    disAmount: number,
    totalAmount: number,
    totalBil: number,
}[]>([]);
const bills = ref<number>(0);
const grandSum = ref<{
    grandSumBil: number,
    grandSumAmount: number,
}>({
    grandSumBil: 0,
    grandSumAmount: 0,
});
const yearSelected = ref<number>(data.year);
const wrapper = ref<HTMLDivElement>();
const olderOffice = ref<boolean>();

onMounted(() => {
    initDateData();
    yearSelected.value = data.year;
    getData();
    setTimeout(()=>{
        if (wrapper.value) {
            wrapper.value.style.height = `calc(100svh - ${window.scrollY + wrapper.value?.getBoundingClientRect()?.top + 20}px)`; //.getBoundingClientRect()?.top
        }
    },1000)
});

const getData = (): void => {
    emitToParent("showLoader");
    let postData: {
        csrf: string,
        year: number,
        wantOld?: number
    } = {
        csrf: data.csrf,
        year: yearSelected.value,
    };
    if (olderOffice.value === true) {
        postData = { ... postData, wantOld: 1} ;
    }
        axios({
            method: "post",
            url: data.uri_get_kaunter_bulan,
            data: postData,
            headers: {"Content-Type": "application/json"}
        }).then(function (response) {
            kaunterBulan.value = response.data.kaunterBulan;
            months.value = response.data.months;
            bills.value = response.data.bills;
            grandSum.value.grandSumBil = response.data.grandSumBil;
            grandSum.value.grandSumAmount = response.data.grandSumAmount;
            emitToParent("hideLoader");
        }).catch(function (error: AxiosError) {
            emitToParent("hideLoader");
            Swal.fire({
                icon: "error",
                title: "Ralat berlaku",
                text: "Sila cuba semula untuk cari. " + error.request.statusText,
                timer: 3000,
                timerProgressBar: true,
                confirmButtonColor: "#0d6efd",
                confirmButtonText: "Ok",
            })
        });
}

const goBack = () :void =>{
    emitToParent("hidePage", true);
}

const initDateData = (): void =>{
    for(let y = data.year; y >= 2015; y--){
        yearRange.value.push(y);
    }
}

</script>

<style scoped>
table{
    border-collapse: separate;
    border-spacing: 0;
}
.wrapper {
    width: 100%;
    overflow: auto;
}

.wrapper th {
    position: sticky;
    z-index: 999;
    left: 0;
}

table > thead > tr:nth-child(2) > th
{
    min-width: 150px;
    height: 70px;
}
.wrapper td {
    padding: 5px;
    width: 30px;
    min-width: 30px;
}

.wrapper th:nth-child(1):not(:last-child),
.wrapper td:nth-child(1):not(:last-child) {
    position: sticky;
    left: 0;
}

.wrapper th:nth-child(2):not(:last-child),
.wrapper td:nth-child(2):not(:last-child) {
    position: sticky;
    left: 30px;
}

.wrapper td:nth-child(1):not(:last-child),
.wrapper td:nth-child(2):not(:last-child) {
    background-color: #5A1C50;
    border: 1px solid white;
}

tr:nth-child(2) > th:nth-child(n+0) {
    position: sticky;
    top: 0;
    border: 1px solid black;
}

tr:nth-child(3) > th:nth-child(n+0){
    position: sticky;
    top: 70px;
    border: 1px solid black;
}

tr:nth-child(1) > th:nth-child(4) /* Jumlah*/
{
    position: sticky;
    top: 0;
    border: 1px solid black;
}
</style>
